// extracted by mini-css-extract-plugin
export default {"accordionItem":"R8KDX","mobile":"ItnWo","smallMobile":"Xdhth","active":"Z7J9X","tablet":"ox7a9"};